import './skeleton.css'

export const AccordionSkeleton = ({
  isBorderTop = true,
  accordionUnavailableClassName
}: {
  isBorderTop?: boolean
  accordionUnavailableClassName?: string
}) => {
  return (
    <div
      className={`flex gap-4 ${isBorderTop ? 'border-t border-[#EBF2F2]' : ''} ${accordionUnavailableClassName ?? ''}`}
    >
      <div className='h-10 w-10 skeleton rounded-lg' />
      <div className='flex flex-col py-1 justify-between text-[#8E9393]'>
        <div className='h-4 w-24 skeleton' />
        <div className='h-3 w-14 skeleton' />
      </div>
    </div>
  )
}
